import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g filter="url(#filter0_d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5V17H18V5H6ZM5.4 2C4.07452 2 3 3.07452 3 4.4V17.6C3 18.9255 4.07452 20 5.4 20H18.6C19.9255 20 21 18.9255 21 17.6V4.4C21 3.07452 19.9255 2 18.6 2H5.4Z"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 3.00001L4.00001 20L3.29291 19.2929L20.2929 2.29291L21 3.00001Z"
      fill="#FF0000"
    />
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </React.Fragment>,
  `WithoutStroke`
);
